module.exports = __webpack_public_path__ + "img/ufc.4a3c9722.jpg";